import React, { useEffect, useState, useCallback } from 'react';
import { listOverrides, deleteOverride } from '../../services/syncApi';
import useDebouncedValue from '../../hooks/useDebouncedValue';

const OverridesList = () => {
  const [overrides, setOverrides] = useState([]);
  const [skuDraft, setSkuDraft] = useState('');
  const filterSku = useDebouncedValue(skuDraft);
  const [filterMarket, setFilterMarket] = useState('');

  const load = useCallback(async () => {
    const params = {};
    if (filterSku) params.sku = filterSku;
    if (filterMarket) params.market_code = filterMarket;
    setOverrides(await listOverrides(params));
  }, [filterSku, filterMarket]);

  useEffect(() => { load(); }, [load]);

  const remove = async (id) => {
    if (!window.confirm('Remove this override?')) return;
    await deleteOverride(id);
    load();
  };

  return (
    <div className="overrides-list">
      <header><h1>Overrides</h1></header>
      <section className="card">
        <div className="filters">
          <label>SKU
            <input
              value={skuDraft}
              onChange={(e) => setSkuDraft(e.target.value)}
              placeholder="Wildcards * and ? (244*)"
            />
          </label>
          <label>Market
            <select value={filterMarket} onChange={(e) => setFilterMarket(e.target.value)}>
              <option value="">All</option>
              <option value="AU">AU</option>
              <option value="NZ">NZ</option>
            </select>
          </label>
        </div>
        <p className="muted">Overrides change the <em>desired</em> state. Removing one re-runs the diff against the underlying mapping.</p>
        <table>
          <thead>
            <tr>
              <th>SKU</th><th>Market</th><th>Target</th><th>Field</th>
              <th>Forced value</th><th>Reason</th><th>Created by</th>
              <th>Created at</th><th>Expires</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {overrides.map((o) => (
              <tr key={o.id}>
                <td>{o.sku}</td>
                <td>{o.market_code}</td>
                <td>{o.bc_target}</td>
                <td>{o.bc_field_name}</td>
                <td><code>{JSON.stringify(o.forced_value)}</code></td>
                <td>{o.reason || '—'}</td>
                <td>{o.created_by}</td>
                <td>{new Date(o.created_at).toLocaleString()}</td>
                <td>{o.expires_at ? new Date(o.expires_at).toLocaleString() : '—'}</td>
                <td><button type="button" onClick={() => remove(o.id)}>Remove</button></td>
              </tr>
            ))}
            {overrides.length === 0 && <tr><td colSpan={10} className="muted">No overrides.</td></tr>}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default OverridesList;
